import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import PageHero from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import { WHY_CHOOSE, IMG } from "@/data/content";

export default function WhyUs() {
  return (
    <div data-testid="why-us-page">
      <PageHero
        overline="Why Choose Us"
        lines={["Because Your Farm", "Deserves More Than", "Guesswork"]}
        subtitle="Every farm we touch is backed by agronomic data, transparent budgeting, and a partnership that lasts well beyond installation."
        testId="why-us-hero"
      />

      <section className="border-b border-border">
        <div className="mx-auto max-w-[1400px] px-5 md:px-10 grid grid-cols-1 lg:grid-cols-2">
          <div className="border-l border-border">
            {WHY_CHOOSE.map((w, i) => (
              <Reveal key={w.title}>
                <div className="p-8 md:p-12 border-r border-b border-t border-border first:border-t-0">
                  <div className="flex items-baseline gap-5">
                    <span className="font-mono text-primary text-sm">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <h3 className="font-clash text-2xl md:text-3xl">{w.title}</h3>
                  </div>
                  <p className="mt-4 md:pl-11 text-lg text-muted-foreground leading-relaxed">
                    {w.text}
                  </p>
                </div>
              </Reveal>
            ))}
          </div>
          <div className="relative hidden lg:block">
            <img
              src={IMG.heroGreenhouse}
              alt="Polyhouse interior"
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-background/70 to-transparent" />
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-[1400px] px-5 md:px-10 py-24 md:py-32">
        <Reveal>
          <h2 className="font-clash text-3xl md:text-5xl tracking-tight max-w-3xl">
            One partner, every stage — from first consultation to final harvest.
          </h2>
          <Link
            to="/contact"
            data-testid="why-us-cta"
            className="group mt-10 overline inline-flex items-center gap-3 bg-primary text-primary-foreground px-8 py-4 font-bold transition-transform duration-300 hover:scale-[1.04]"
          >
            Start Your Project
            <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </Link>
        </Reveal>
      </section>
    </div>
  );
}
